import React from 'react';
import './SearchBar.scss';

export default function SearchBar({ value, onChange, placeholder }) {
  return (
    <label className="search-box">
      <input
        type="text"
        required
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
<ul>
  <li>s</li>
  <li>e</li>
  <li>a</li>
  <li>r</li>
  <li>c</li>
  <li>h</li>
</ul>
    </label>
  );
}
